import './EditDialog.scss';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import ToastContext from '../../../../../context/ToastContext';
import useAxios from '../../../../../hooks/useAxios';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import { Locker, LockerFormData } from '../../../../../types/api/lockers';
import {
  errorToast,
  successToast,
} from '../../../../../utils/helpers/primereact';
import { toApiData } from './EditDialog.functions';
import FormContainer from './FormContainer';

type Props = {
  visible: boolean;
  onHide: () => void;
  data: Locker | undefined;
  isLoading: boolean;
  reload: () => void;
};

function EditDialog({ visible, onHide, data, reload }: Props) {
  const { t } = useTranslation();
  const { toastRef } = useContext(ToastContext);

  const { reload: formSubmitRequest, isLoading: isFormSubmitRequestLoading } =
    useAxios();

  function handleSubmitForm(values: LockerFormData) {
    formSubmitRequest({
      url: `/lockers/${data?.id}`,
      payload: toApiData(values),
      method: 'PUT',
      successCallback: () => {
        successToast(
          toastRef,
          t('Success'),
          t('Locker {{name}} has been edited successfully', {
            name: data?.title,
          })
        );
        reload();
        onHide();
      },
      errorCallback: (err: any) => {
        console.log('err ', err);
        errorToast(toastRef, t('Error'), t('An error occured ', err));
        return;
      },
    });
  }

  const dialogHeader = data?.title;

  const dialogFooter = (
    <div>
      <Button
        type="button"
        label={t('Cancel')}
        className="p-button-secondary p-button-text"
        onClick={() => onHide()}
      />

      <Button
        type="submit"
        form="locker-edit-form"
        label={isFormSubmitRequestLoading ? t('Saving...') : t('Save changes')}
        disabled={isFormSubmitRequestLoading}
        className="p-button-primary"
        data-cy="submit"
      />
    </div>
  );

  const isOnMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={dialogHeader}
      footer={dialogFooter}
      blockScroll
      resizable={false}
      maximizable
      maximized={isOnMobile}
      className="lockers-edit-dialog"
    >
      <FormContainer handleSubmitForm={handleSubmitForm} data={data} />
    </Dialog>
  );
}

export default EditDialog;
